// extracted by mini-css-extract-plugin
export default {"wrapper":"mh-z","side":"nh-z","boxNumSelection":"oh-z","disabled":"ph-z","boxInfoMsg":"qh-z","noReturnItems":"rh-z","breadcrumb":"sh-z"};